import React from 'react'

const Flexbox_Coding_Pratice_1 = () => {
  return (
    <div>
      <h1>Flexbox Coding Practice 1</h1>
    </div>
  )
}

export default Flexbox_Coding_Pratice_1
